(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-promo-ribbon"] && !Shopify.designMode) return;
  try {
    
  class NbPromoTicker extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.paused = false;
      this.inView = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button = this.querySelector('button');
      const options = { signal: this.events.signal };
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      this.setAttribute('data-ready', '');
    }
    sync() {
      this.toggleAttribute('data-running', this.inView && !document.hidden && !this.paused && !this.motion.matches);
    }
    disconnectedCallback() {
      this.events.abort();
      this.observer.disconnect();
    }
  }
  if (!customElements.get('nb-promo-ticker')) customElements.define('nb-promo-ticker', NbPromoTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-highlights"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nb-review-preview')) {
  customElements.define('nb-review-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const refresh = () => requestAnimationFrame(() => { if (this.isConnected) this.render(); });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true, signal: this.controller.signal });
      else refresh();
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.querySelector('nb-manual-reviews')) refresh();
        }, { signal: this.controller.signal });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.querySelector('nb-manual-reviews')) refresh();
        }, { signal: this.controller.signal });
      }
    }
    disconnectedCallback() {
      this.controller.abort();
    }
    render() {
      const source = document.querySelector('nb-manual-reviews:not([data-review-continuation="true"])');
      const cards = source ? [...(source.cards || source.querySelectorAll('[data-review]'))].filter(card => card.dataset.filled === 'true') : [];
      this.hidden = cards.length === 0;
      const list = this.querySelector('[data-preview-list]');
      list.replaceChildren();
      if (!cards.length) return;
      const average = cards.reduce((total, card) => total + Number(card.dataset.rating), 0) / cards.length;
      this.querySelector('[data-preview-rating]').textContent = 'Rated ' + average.toFixed(1) + '/5 by ' + cards.length + ' customers';
      this.querySelector('[data-preview-stars]').style.setProperty('--preview-fill', (average * 20) + '%');
      this.querySelectorAll('[data-preview-all]').forEach(link => { link.href = '#' + source.id; });
      const fragment = document.createDocumentFragment();
      cards.slice(0, 3).forEach(card => {
        const preview = this.querySelector('[data-preview-card]').content.cloneNode(true);
        const author = card.querySelector('.nb-reviews__author').cloneNode(true);
        author.querySelectorAll('.nb-reviews__avatar, .nb-reviews__verified').forEach(item => item.remove());
        preview.querySelector('[data-preview-name]').textContent = author.textContent.trim();
        preview.querySelector('[data-preview-avatar]').textContent = card.querySelector('.nb-reviews__avatar').textContent;
        const stars = preview.querySelector('[data-preview-card-stars]');
        stars.style.setProperty('--preview-fill', (Number(card.dataset.rating) * 20) + '%');
        stars.setAttribute('aria-label', card.querySelector('.nb-reviews__stars').getAttribute('aria-label'));
        const title = preview.querySelector('[data-preview-title]');
        title.textContent = card.querySelector('h3')?.textContent || '';
        title.hidden = !title.textContent;
        const body = card.querySelector('.nb-reviews__body').textContent.trim();
        const long = body.length > 120;
        preview.querySelector('[data-preview-excerpt]').textContent = long ? body.slice(0, 120).replace(/\s+\S*$/, '') + '…' : body;
        preview.querySelector('[data-preview-body]').textContent = body;
        preview.querySelector('[data-preview-details]').hidden = !long;
        card.querySelectorAll('.nb-reviews__review-photos img').forEach(photo => {
          const image = photo.cloneNode(false);
          image.removeAttribute('id');
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 64;
          image.height = 64;
          image.sizes = '64px';
          preview.querySelector('[data-preview-photos]').append(image);
        });
        fragment.append(preview);
      });
      list.append(fragment);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-preview"]) return;
  try {
    
  if (!customElements.get('nb-wrap-review-preview')) {
    customElements.define('nb-wrap-review-preview', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => { if (this.isConnected) this.render(); });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true, signal: this.events.signal });
        else refresh();
        customElements.whenDefined('nb-manual-reviews').then(() => { if (this.isConnected) refresh(); });
        document.addEventListener('shopify:section:load', refresh, { signal: this.events.signal });
        document.addEventListener('shopify:section:unload', refresh, { signal: this.events.signal });
      }
      disconnectedCallback() {
        this.events.abort();
        cancelAnimationFrame(this.frame);
        this.resize?.disconnect();
      }
      render() {
        this.resize?.disconnect();
        const source = document.getElementById(this.dataset.sourceId) || document.querySelector('nb-manual-reviews:not([data-review-continuation="true"])');
        const cards = source ? (source.cards || [...source.querySelectorAll('[data-review]')]).filter(card => card.dataset.filled === 'true') : [];
        if (!cards.length) { this.hidden = true; return; }
        const accent = source.style.getPropertyValue('--review-accent');
        this.style.setProperty('--review-accent', accent);
        const href = '#' + source.id;
        const rating = this.querySelector('[data-preview-rating]');
        rating.href = href;
        const average = cards.reduce((sum, card) => sum + Number(card.dataset.rating), 0) / cards.length;
        const summaryStars = cards[0].querySelector('.nb-reviews__stars').cloneNode(true);
        summaryStars.style.setProperty('--star-fill', (average * 20) + '%');
        summaryStars.removeAttribute('aria-label');
        summaryStars.removeAttribute('role');
        summaryStars.setAttribute('aria-hidden', 'true');
        const score = document.createElement('span');
        score.className = 'nb-reviews__score';
        score.textContent = this.dataset.scoreLabel.replace('[rating]', average.toFixed(2));
        const count = document.createElement('span');
        count.className = 'nb-wrap-review-preview__count';
        count.textContent = this.dataset.countLabel.replace('[count]', String(cards.length));
        rating.replaceChildren(summaryStars, score, count);
        this.querySelector('[data-preview-all]').href = href;
        const grid = this.querySelector('[data-preview-grid]');
        grid.replaceChildren();
        cards.slice(0, 3).forEach((original, index) => {
          const card = document.createElement('article');
          card.className = 'nb-wrap-review-preview__card';
          card.append(original.querySelector('.nb-reviews__author').cloneNode(true));
          const top = original.querySelector('.nb-reviews__review-top').cloneNode(true);
          const stars = top.querySelector('.nb-reviews__stars');
          const starLink = document.createElement('a');
          starLink.href = href;
          stars.replaceWith(starLink);
          starLink.append(stars);
          card.append(top);
          const title = original.querySelector('h3');
          if (title) card.append(title.cloneNode(true));
          const body = original.querySelector('.nb-reviews__body').cloneNode(true);
          body.className = 'nb-wrap-review-preview__body is-collapsed';
          body.id = this.id + '-body-' + index;
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'nb-wrap-review-preview__more';
          toggle.textContent = this.dataset.more;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-controls', body.id);
          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.textContent = expanded ? this.dataset.less : this.dataset.more;
            body.classList.toggle('is-collapsed', !expanded);
          });
          const content = document.createElement('div');
          content.className = 'nb-wrap-review-preview__content';
          content.append(body, toggle);
          const originalPhotos = original.querySelector('.nb-reviews__review-photos');
          if (originalPhotos) {
            const photos = originalPhotos.cloneNode(true);
            photos.querySelectorAll('[data-photo]').forEach((button, photoIndex) => {
              button.addEventListener('click', () => originalPhotos.querySelectorAll('[data-photo]')[photoIndex].click());
            });
            content.append(photos);
          }
          card.append(content);
          grid.append(card);
        });
        this.hidden = false;
        this.resize = new ResizeObserver(() => {
          grid.querySelectorAll('.nb-wrap-review-preview__body').forEach(body => {
            const toggle = body.nextElementSibling;
            toggle.hidden = toggle.getAttribute('aria-expanded') !== 'true' && body.scrollHeight <= body.clientHeight + 1;
          });
        });
        this.resize.observe(grid);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nb-manual-reviews')) {
    customElements.define('nb-manual-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized || this.dataset.reviewContinuation === 'true') return;
        this.initialized = true;
        const start = () => {
          if (!this.isConnected) return;
          const series = this.dataset.reviewSeries;
          if (series) {
            document.querySelectorAll('nb-manual-reviews[data-review-continuation="true"]').forEach((continuation) => {
              if (continuation.dataset.reviewSeries !== series) return;
              continuation.querySelectorAll('[data-review]').forEach((card) => this.querySelector('.nb-reviews__list').append(card));
              continuation.hidden = true;
            });
          }
          this.cards = [...this.querySelectorAll('[data-review]')];
          this.page = 1;
          this.search = this.querySelector('[data-search]');
          this.sort = this.querySelector('[data-sort]');
          this.dialog = this.querySelector('.nb-reviews__lightbox');
          this.controller = new AbortController();
          this.search.addEventListener('input', () => { this.page = 1; this.render(); });
          this.sort.addEventListener('change', () => { this.page = 1; this.render(); });
          this.addEventListener('click', (event) => {
          if (event.target.closest('[data-write-review]')) {
            this.querySelector('nb-review-composer').open();
            return;
          }
          const photo = event.target.closest('[data-photo]');
          if (photo) {
            const image = new Image();
            image.src = photo.dataset.photo;
            image.alt = photo.querySelector('img').alt;
            this.querySelector('[data-lightbox-image]').replaceChildren(image);
            this.dialog.showModal();
            return;
          }
          if (event.target.closest('.nb-reviews__close') || event.target === this.dialog) this.dialog.close();
          const feedback = event.target.closest('[data-feedback]');
          if (feedback) {
            const card = feedback.closest('[data-review]');
            const choice = feedback.dataset.feedback;
            const activeChoice = card.dataset.feedback;
            card.dataset.feedback = activeChoice === choice ? '' : choice;
            card.querySelectorAll('[data-feedback]').forEach(item => {
              const active = item.dataset.feedback === card.dataset.feedback;
              item.setAttribute('aria-pressed', active.toString());
              item.querySelector('[data-feedback-count]').textContent = String(Number(item.dataset.feedbackBase || 0) + (active ? 1 : 0));
            });
            return;
          }
          const button = event.target.closest('.nb-reviews__pagination button');
          if (!button || button.disabled) return;
          const edge = button.dataset.edge;
          this.page = edge === 'first' ? 1 : edge === 'previous' ? this.page - 1 : edge === 'next' ? this.page + 1 : edge === 'last' ? this.pageCount : Number(button.dataset.page);
          this.render();
          this.querySelector('.nb-reviews__toolbar').scrollIntoView({ block: 'start', behavior: 'auto' });
        });
          document.addEventListener('shopify:block:select', (event) => {
            const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
            if (!card) return;
            this.search.value = '';
            this.sort.value = 'manual';
            this.page = Math.floor(this.cards.indexOf(card) / 5) + 1;
            this.render();
            card.scrollIntoView({ block: 'center', behavior: 'auto' });
          }, { signal: this.controller.signal });
          if (window.Shopify?.designMode) {
            document.addEventListener('shopify:section:load', (event) => {
              if (event.target.querySelector('[data-lumbar-review-summary]')) this.updateSummary();
            }, { signal: this.controller.signal });
          }
          this.updateSummary();
          this.render();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
        else start();
      }
      updateSummary() {
        const filled = this.cards.filter((card) => card.dataset.filled === 'true');
        const count = filled.length;
        const average = count ? filled.reduce((total, card) => total + Number(card.dataset.rating), 0) / count : 0;
        const rounded = average.toFixed(2);
        this.querySelector('[data-review-overall]').textContent = rounded;
        this.querySelector('[data-review-score]').textContent = rounded + ' out of 5';
        this.querySelector('[data-review-count]').textContent = 'Based on ' + count + ' reviews';
        document.querySelectorAll('[data-lumbar-review-summary]').forEach((link) => {
          link.hidden = count === 0;
          link.href = '#' + this.id;
          link.style.setProperty('--rating-fill', (average * 20) + '%');
          link.querySelector('[data-lumbar-review-summary-text]').textContent = 'Rated ' + average.toFixed(1) + '/5 by ' + count + ' customers';
        });
        this.querySelectorAll('[data-review-level]').forEach((row) => {
          const level = Number(row.dataset.reviewLevel);
          const levelCount = filled.filter((card) => Number(card.dataset.rating) === level).length;
          row.querySelector('[data-review-frequency]').textContent = levelCount;
          row.querySelector('.nb-reviews__bar > span').style.width = count ? (levelCount / count * 100) + '%' : '0%';
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      render() {
        const query = this.search.value.toLocaleLowerCase().trim();
        const cards = this.cards.filter(card => card.textContent.toLocaleLowerCase().includes(query));
        const sort = this.sort.value;
        if (sort === 'pictures') {
          cards.sort((a, b) => {
            const aPhotoGroup = a.dataset.reviewType === 'review_page';
            const bPhotoGroup = b.dataset.reviewType === 'review_page';
            if (aPhotoGroup !== bPhotoGroup) return aPhotoGroup ? -1 : 1;
            if (aPhotoGroup) return this.cards.indexOf(a) - this.cards.indexOf(b);
            return (Date.parse(b.dataset.reviewDate) || 0) - (Date.parse(a.dataset.reviewDate) || 0) || this.cards.indexOf(a) - this.cards.indexOf(b);
          });
        }
        if (sort === 'highest') cards.sort((a, b) => Number(b.dataset.rating) - Number(a.dataset.rating));
        if (sort === 'lowest') cards.sort((a, b) => Number(a.dataset.rating) - Number(b.dataset.rating));
        this.pageCount = Math.ceil(cards.length / 5);
        this.page = Math.max(1, Math.min(this.page, this.pageCount));
        this.cards.forEach(card => { card.hidden = true; });
        const list = this.querySelector('.nb-reviews__list');
        cards.forEach((card, index) => {
          list.append(card);
          card.hidden = index < (this.page - 1) * 5 || index >= this.page * 5;
        });
        const pages = this.querySelector('[data-pages]');
        pages.replaceChildren();
        const numbers = [...new Set([1, this.pageCount, ...Array.from({ length: 3 }, (_, index) => this.page + index - 1)])].filter(number => number >= 1 && number <= this.pageCount).sort((a, b) => a - b);
        let previous = 0;
        for (const number of numbers) {
          if (previous && number - previous > 1) {
            const gap = document.createElement('span');
            gap.textContent = '…';
            gap.setAttribute('aria-hidden', 'true');
            gap.className = 'nb-reviews__page-gap';
            pages.append(gap);
          }
          previous = number;
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = number;
          button.dataset.page = number;
          button.setAttribute('aria-label', this.dataset.pageLabel + ' ' + number);
          if (number === this.page) button.setAttribute('aria-current', 'page');
          pages.append(button);
        }
        this.querySelectorAll('[data-edge]').forEach(button => {
          button.disabled = ['first', 'previous'].includes(button.dataset.edge) ? this.page === 1 : this.page >= this.pageCount;
        });
        this.querySelector('.nb-reviews__pagination').hidden = this.pageCount < 2;
        this.querySelector('[data-empty]').hidden = cards.length > 0;
        this.querySelector('[data-status]').textContent = this.pageCount ? this.dataset.pageLabel + ' ' + this.page + ' / ' + this.pageCount : '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
